import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const jiraIssuePickerFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'jira-issue-picker-form-field-extension',
    params: {
      field: () =>
        import('./jira-issue-picker').then(m => m.JiraIssuePickerFormField),
    },
  });
